import type { Brand, BrandId } from 'types/brands'
import { urlNormalize } from 'utils/url/urlNormalize'

import { flatBrands } from './flatBrands'
import { getBrandTranslationKeys } from './getBrandTranslationKeys'
import { getSubbrands } from './getSubBrands'

export const matchBrandFromUrl = ({
	urlBrands,
	translate,
	brands,
}: {
	urlBrands: string[]
	translate: (key: string) => string
	brands: Brand[]
}): Brand | undefined => {
	const subBrands = getSubbrands(brands)
	const decodedUrlBrands = urlBrands.map((urlBrand) =>
		urlNormalize(decodeURIComponent(urlBrand))
	)

	const flattedBrands = flatBrands(brands)
	const urlBrandNames: Partial<Record<BrandId, string>> = {}

	for (const brand of flattedBrands) {
		const brandUrlKey = getBrandTranslationKeys(brand.id, flattedBrands)?.urlKey
		const urlEncodedBrandName =
			brandUrlKey && urlNormalize(translate(brandUrlKey))

		if (urlEncodedBrandName) {
			urlBrandNames[brand.id] = urlEncodedBrandName
		}
	}

	const brandFinder = (brandsList: Brand[]): Brand | undefined =>
		decodedUrlBrands.reduceRight<Brand | undefined>(
			(foundBrand, urlBrand) =>
				foundBrand ||
				brandsList.find((brand) => urlBrandNames[brand.id] === urlBrand),
			undefined
		)

	let matchedBrand = brandFinder(subBrands)

	if (!matchedBrand) {
		matchedBrand = brandFinder(brands)
	}

	return matchedBrand
}
